import styled from "styled-components";

import UINotificationBase from "./Base";

const UINotificationWarning = styled(UINotificationBase)`
  background: #ffff99;
  webkit-box-shadow: 0 4px 6px -6px #222;
  -moz-box-shadow: 0 4px 6px -6px #222;
  box-shadow: 0 4px 6px -6px #222;
`;

export default UINotificationWarning;
